import { Button } from "@legal-500/legal500-design-system";
import { countBlocking, type FamilyConflict } from "./findFamilyConflicts.js";
import { downloadConflictsCsv } from "./moveToSetCsv.js";
import styles from "../PipelineBrowser.module.css";

const DISPLAY_CAP = 50;

const SEVERITY_LABELS: Record<FamilyConflict["severity"], string> = {
  blocking: "Blocking",
  warning: "Warning",
};

type MoveToSetFamilyConflictsProps = {
  conflicts: FamilyConflict[];
  heading?: string;
  listLabel?: string;
};

export function MoveToSetFamilyConflicts({
  conflicts,
  heading = "Family check",
  listLabel = "Family conflicts",
}: MoveToSetFamilyConflictsProps) {
  if (conflicts.length === 0) {
    return <div className={styles.syncStateMessage}>{heading}: no conflicts.</div>;
  }
  const blocking = countBlocking(conflicts);
  const shown = conflicts.slice(0, DISPLAY_CAP);
  const hidden = conflicts.length - shown.length;

  return (
    <>
      <div className={styles.syncStateRow}>
        <span className={styles.syncStateMessage}>
          {heading}: <strong>{blocking}</strong> blocking,{" "}
          <strong>{conflicts.length - blocking}</strong> warnings.
        </span>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => downloadConflictsCsv(conflicts, new Date())}
        >
          Download conflicts CSV
        </Button>
      </div>
      <ul className={styles.problemList} aria-label={listLabel}>
        {shown.map((conflict, index) => (
          <li key={`${index}-${conflict.mateId}`}>
            {SEVERITY_LABELS[conflict.severity]}: {conflict.mateId}, found through{" "}
            {conflict.requestedId}: {conflict.reason}
          </li>
        ))}
      </ul>
      {hidden > 0 && <div className={styles.syncStateMessage}>…and {hidden} more.</div>}
    </>
  );
}
